import { render, staticRenderFns } from "./OliverSalesAchievements.vue?vue&type=template&id=15acb050"
import script from "./OliverSalesAchievements.vue?vue&type=script&lang=js"
export * from "./OliverSalesAchievements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports